import { WideButton } from "@coworker/components/src/components/Button";
import styled from "styled-components";
import Question from "./Question";
import { useTranslation } from "@coworker/locales";
import taskState from "@coworker/enums/taskState";
import { mfaqTaskKey } from "./hooks/usePendingMfaqTasks";

const ButtonContainer = styled("div")`
  width: 15rem;
  margin: auto;
`;

const QuestionsContainer = styled("div")`
  width: 100%;
`;

function Questions({
  questions,
  updateFrom,
  shouldShowLoadMore = false,
  canUpvote,
  showUpvote,
  selectedArea,
  dataTestId = "questionsContainer",
  activeV2TasksByKey,
}) {
  const { t } = useTranslation();
  if (!questions?.length) return null;
  return (
    <QuestionsContainer data-testid={dataTestId}>
      {Array.isArray(questions) &&
        questions.map((question) => {
          const v1OngoingTaskCreatedAt = getOngoingTaskCreatedAt(
            question?.tasks
          );
          const v2Task = activeV2TasksByKey?.get(
            mfaqTaskKey(question?.question_id ?? "", selectedArea ?? "")
          );
          // Show orange flag for either v1 or v2 active task; v2 takes priority.
          const ongoingTaskCreatedAt =
            v2Task?.created_at ?? v1OngoingTaskCreatedAt ?? null;
          return (
            <Question
              key={question?.question_id}
              question_id={question?.question_id}
              questionText={question?.question_text}
              upvotesCount={question?.upvotes}
              lastAskedAt={question?.last_asked_at}
              canUpvote={canUpvote}
              showUpvote={showUpvote}
              selectedArea={selectedArea}
              ongoingTaskCreatedAt={ongoingTaskCreatedAt}
            />
          );
        })}
      {shouldShowLoadMore && (
        <ButtonContainer>
          <WideButton
            data-testid="loadMoreQuestions"
            secondary
            dark={true}
            disabled={false}
            text={t("loadMore")}
            onClick={() => updateFrom()}
          />
        </ButtonContainer>
      )}
    </QuestionsContainer>
  );
}

/**
 * Returns the created_at of the first active (non-completed, non-closed) task
 * found for the question, regardless of area. Original v1 behaviour — tasks
 * are not sorted, so the order depends on the server response.
 */
function getOngoingTaskCreatedAt(tasks) {
  const hasOngoingTask =
    tasks &&
    Array.isArray(tasks) &&
    tasks.filter(
      (task) =>
        task.state !== taskState.COMPLETED && task.state !== taskState.CLOSED
    );
  return !!hasOngoingTask?.length && hasOngoingTask[0].created_at;
}

export default Questions;
